import React,{ useState, useEffect } from "react";
import { 
    Card,
    Button, 
    ConfigProvider
} from 'antd';

import { 
    ArrowDownOutlined,
    ArrowUpOutlined,
    LaptopOutlined,
    PhoneOutlined
} from '@ant-design/icons';

import StartTVLogo from '../../../images/promos/november/start-tv-logo.png';

function InternetProductCard( { 
    productData,
    handleAddToCart,
    activeProductId,
    addingToCart,
    isCartComponent,
    isLoading,
    isPlaceholder } ) {
    //console.log("addingToCart: ", addingToCart);
    //console.log("activeProductId: ", activeProductId);
    //console.log("isPlaceholder: ", isPlaceholder);
    //console.log("productData: ", productData);

    let loading = ( addingToCart && ( activeProductId == productData.service_id ) ) ? true : false;
    let active = ( activeProductId == productData.service_id ) ? true : false;
    
    const getCardActionMarkup = () => {
        if( productData.qualified ) {
            let purchaseAction = '';
            let showTerms = ((productData.marked_down_from != null || productData.bundled_savings != null)) ? true : false;
            for( let i=0; i < productData.actions.length; i++ ) {
                if( productData.actions[i].service.service_id == productData.sku ) {
                    purchaseAction = productData.actions[i].service.action;
                }
            }

            if( purchaseAction == 'connect' ) {
                return(
                    <Button 
                        type="primary" 
                        className="ant-btn css-dev-only-do-not-override-xu9wm8 ant-btn-primary"
                        loading={ loading }
                        icon={<PhoneOutlined />}
                        onClick={ () => { document.location.href = 'tel:1-866-434-5888' } }>
                        Call 1-866-434-5888
                    </Button> 
                )
            } else if( purchaseAction == 'buy' ) {
                return(
                    <>
                        <Button 
                            type="primary" 
                            className="ant-btn css-dev-only-do-not-override-xu9wm8 ant-btn-primary"
                            loading={ loading } 
                            onClick={ () => handleAddToCart( productData.service_id, productData.product_name )}>
                            Select Plan
                        </Button>
                        <a 
                            className="beat-the-heat-deal-terms-conditions" href="/flashsale-internet-tv" target="_blank" 
                            style={{fontSize: '0.8rem', margin:'0.5rem 0', display:( showTerms )? 'block': 'none' }}>
                                Terms and conditions apply. 
                        </a>
                    </>
                )
            }
        }else {
            return(
                <Button 
                    type="primary" 
                    class="internet-package-check-availability-button"
                    onClick={ handleCheckAvailability }>
                    Check Availability
                </Button>
            )
        }
    }

    const handleCheckAvailability = ( e ) => {

        document.dispatchEvent(new CustomEvent('qualificationModalUpdateState', { detail: '' }));

        //console.log( 'isCartComponent: ', isCartComponent );
        //setComponentCompleted( false );
        //let checkAvailabilityBtn = jQuery(".check-availability-btn .elementor-button, .internet-package-check-availability-button");
        //let checkAvailabilityOverlay = jQuery(".modal-overlay");
        //let addressInput = jQuery("#check-availability-modal-address-input");

        //checkAvailabilityOverlay.toggleClass("active");

        //if( isCartComponent ) {
            //checkAvailabilityOverlay.addClass("cart-component");
        //}

        //addressInput.focus();
    }

    if( isPlaceholder ) {
        return <Card
            className="product-card"
            loading={ true }
            title={ '' } 
            bordered={ active }>
            
            <div className="product-card-content">
                <div className="product-card-detail-container"></div>
            </div>
        </Card>
    } else {
        let reccomendedClass = ( productData.service_id == 1376  && productData.qualified == false  ) ? 'recommended' : '';
        let markedDownFrom = productData.marked_down_from;
        let bundlesdSavings = productData.bundled_savings;

        //console.log('bundledSavings:: ', bundlesdSavings);

        return (
            <Card
                className={ `product-card ${ reccomendedClass }` }
                loading={ isLoading }
                hoverable
                title={
                    <div className="product-price">
                        <div className="product-title">{ productData.product_name }</div>
                        <div className="product-price-container">
                            <div className="">
                                <span className="dolla">$</span>
                                <span className="price">{ productData.post_meta['_price'][0] }</span>
                                <span className="duration">/mo</span>
                            </div>
                            <div 
                                className="product-card-tv-promo-callout" style={{ display: ( bundlesdSavings != null && productData.qualified ) ? 'flex' : 'none' }}
                                onClick={ () => document.location.href = '/services/tv' }
                            >
                                <span>{ bundlesdSavings } <span style={{fontWeight:300}}>with</span></span><img style={{ width:'56px' }} src={ StartTVLogo } />
                            </div>
                        </div>
                    </div>
                }
                bordered={ active }
            >
            
                <div className="product-card-content">
                    <div className="product-card-detail-container">
                        <div className="product-card-detail">
                            <ArrowDownOutlined /><span className="product-card-detail-copy">{ `${productData.download_speed} MBPS Download` }</span>
                        </div>
                        <div className="product-card-detail">
                            <ArrowUpOutlined /><span className="product-card-detail-copy">{ `${productData.upload_speed} MBPS Upload` }</span>
                        </div>
                        <div className="product-card-detail unlimited">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.1777 8C23.2737 8 23.2737 16 18.1777 16C13.0827 16 11.0447 8 5.43875 8C0.85375 8 0.85375 16 5.43875 16C11.0447 16 13.0828 8 18.1788 8H18.1777Z" stroke="#414042" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg><span className="product-card-detail-copy">Unlimited Usage</span>
                        </div>
                        <div className="product-card-detail">
                            <LaptopOutlined /><span className="product-card-detail-copy">{ `Best for ${productData.num_devices} Devices` }</span>
                        </div>
                    </div>
                    { getCardActionMarkup() }
                    
                </div>
            </Card>
        )
    }
}

export default InternetProductCard